// Centralized configuration for NBLReport
const nblReportConfig = {
  reportKey: "nbl_report_column_visibility",

  tableTemplate: [
    { field: "nbl_main_id",            headerName: "NBL Main ID" },
    { field: "employeeid",             headerName: "Employee ID" },
    { field: "employeename",           headerName: "Employee Name" },
    { field: "grade",                  headerName: "Grade" },
    { field: "rev_grade",              headerName: "Rev Grade" },
    { field: "primaryskill",           headerName: "Primary Skill" },
    { field: "secondaryskill",         headerName: "Secondary Skill" },
    { field: "location",               headerName: "Location" },
    { field: "region",                 headerName: "Region" },
    { field: "projectid",              headerName: "Project ID" },
    { field: "projectname",            headerName: "Project Name" },
    { field: "customername",           headerName: "Customer Name" },
    { field: "parentcustomername",     headerName: "Parent Customer Name" },
    { field: "projectregion",          headerName: "Project Region" },
    { field: "market",                 headerName: "Market" },
    { field: "marketunit",             headerName: "Market Unit" },
    { field: "pmid",                   headerName: "PM ID" },
    { field: "pmname",                 headerName: "PM Name" },
    { field: "edl_id",                 headerName: "EDL ID" },
    { field: "edl_name",               headerName: "EDL Name" },
    { field: "allocationstartdate",    headerName: "Allocation Start Date" },
    { field: "allocationenddate",      headerName: "Allocation End Date" },
    { field: "rev_bu",                 headerName: "Rev BU" },
    { field: "vertical",               headerName: "Vertical" },
    { field: "practice",               headerName: "Practice" },
    { field: "rev_prac",               headerName: "Rev Practice" },
    { field: "departmentname",         headerName: "Department" },
    { field: "ei_dpo",                 headerName: "EI / DPO" },
    { field: "action",                 headerName: "Action" },
    { field: "actiondate",             headerName: "Action Date" },
    { field: "billabilitypercentage",  headerName: "Billability %" },
    { field: "predictionutilpercent",  headerName: "Prediction Util %" },
    { field: "comments",               headerName: "Comments" },
    { field: "previouscomments",       headerName: "Previous Comments" },
    { field: "nblageing",              headerName: "NBL Ageing" },
    { field: "ageingbucket",           headerName: "Ageing Bucket" },
    { field: "secondarystatetag",      headerName: "Secondary State Tag" },
    { field: "projectbillability",     headerName: "Project Billability" },
    { field: "cooapproval",            headerName: "COO Approval" },
    { field: "cooapprovaltilldate",    headerName: "COO Approval Till Date" },
    { field: "primarystatetag",        headerName: "Primary State Tag" },
    { field: "last_updated_date",      headerName: "Last Updated Date" },
    { field: "report_extraction_date", headerName: "Report Extraction Date" }
  ],

  filterTemplate: [
    { field: "primaryskill",   headerName: "Primary Skill" },
    { field: "secondaryskill", headerName: "Secondary Skill" },
    { field: "grade",          headerName: "Grade" },
    { field: "region",         headerName: "Region" },
    { field: "location",       headerName: "Location" },
    { field: "practice",       headerName: "Practice" },
    { field: "departmentname", headerName: "Department" },
    { field: "ageingbucket",   headerName: "Ageing Bucket" }
  ]
};

export default nblReportConfig;
